import axios from "axios"
import React, { Component } from "react"
import { Accordion, Card } from "react-bootstrap"
import AxiosConfig from "../../../../../utilities/AxiosConfig"
import ReviewsTypes from "./ReviewsTypes/ReviewsTypes"
import ReviewsReferenceTypes from "./ReviewsTypes/ReviewsReferenceTypes"
import Review from "../Review/Review"
import moment from "moment"
import snackBar from "../../../../../utilities/snackBar/SnackBar"
import ReviewTypes from "../Review/ReviewTypes/EditReviewTypes"
import AddReview from "../Review/AddReview/AddReview"
import EmployeeDataTypes from "../../../Types/EmployeeTypes"
import ReviewsControlBar from "../ReviewsControlsBar/ReviewsControlBar"
import { ReviewHealthContext } from "../../../../../components/vault77/health/ReviewHealthContext"
import ReviewHealthBadge from "../../../../../components/vault77/health/ReviewHealthBadge"
import "./Reviews.css"

interface ReviewsProps {
    contextUser: string | number
    employee: EmployeeDataTypes
    detailedEmployeeData: EmployeeDataTypes | {}
    doublePanelRef: any
    updateEmployee: Function
    readOnly: boolean
    ReviewID?: string | any
    addOrUpdateNotification?: Function
    isDelegation: boolean
    delegatorEmployeeId: number
}

interface ReviewsState {
    loading: boolean
    reviews: Array<ReviewsTypes> | []
    reviewDex: number
    reference: ReviewsReferenceTypes | null
    ascending: boolean
    viewAll: boolean
    addReview: boolean
}

class Reviews extends Component<ReviewsProps, ReviewsState> {

    // Read-only Vault77 health lookup (provided by the Employees page). Used only to flag which review
    // rows the data-quality scan found problems with; absent (default empty) on the deep-link / non-HR
    // paths, in which case rows render unmarked.
    static contextType = ReviewHealthContext
    context!: React.ContextType<typeof ReviewHealthContext>

    state = {
        loading: true,
        reviews: [],
        reviewDex: -1,
        reference: null,
        ascending: true,
        viewAll: false,
        addReview: false,
    }

    componentDidMount() {
        this.getReviewReference()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    updateStatus = (review: any) => {
        let updated = JSON.parse(JSON.stringify(review))
        // //console.log("??? reviews: review", updated)
        let reviews = this.state.reviews
        //@ts-ignore
        const index = reviews.map(function (e) { return e.EmployeeReviewId; }).indexOf(updated.EmployeeReviewId)
        const target = reviews[index]
        // //console.log("??? reviews: target", target)
        for (let key in updated) {
            if (!(key in target))
                delete updated[key]
        }
        //@ts-ignore
        updated = { ...target, ...updated }
        // //console.log("??? reviews: updated", updated)
        //@ts-ignore
        reviews[index] = updated
        this.manageState([{ key: "reviews", value: reviews }])
    }

    handleSingleView = (id: string, reviews: Array<ReviewsTypes> | []) => {
        let reviewId = parseInt(id)
        for (let i = 0; i < reviews.length; i++) {
            if (reviews[i].EmployeeReviewId === reviewId) {
                this.setState({ reviewDex: i })
            }
        }
    }

    getReviewReference = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/reference`, AxiosConfig.configValue("min"))
            .then((res) => {
                this.manageState([{ key: "reference", value: res.data }])
                this.getReviews()
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }

    getReviews = (reviewToOpen?: number) => {
        this.manageState([{ key: "loading", value: true }])
        axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/getEmployeeReviewList/${this.props.employee.UserId}`, AxiosConfig.configValue("min"))
            .then((res) => {
                const reviews = res.data
                this.manageState(
                    [
                        { key: "reviews", value: reviews },
                        { key: "loading", value: false },
                        { key: "addReview", value: false },
                        { key: "deleteReview", value: false }
                    ])
                if (reviewToOpen) {
                    for (let i = 0; i < reviews.length; i++) {
                        if (reviews[i].EmployeeReviewId) {
                            this.manageState([{ key: "reviewDex", value: i }])
                        }
                    }
                }

                if (this.props.ReviewID) {
                    this.handleSingleView(this.props.ReviewID, res.data)
                }

                if(this.props.isDelegation){
                    for (let i = 0; i < reviews.length; i++) {

                    } 
                }
            })
            .catch((err) => {
                snackBar({ type: "danger", text: "There was an error fetching reviews for this employee", timeout: 3000 })
            })
    }

    addOrDeleteReview = (review: ReviewTypes) => {
        this.manageState([{ key: "loading", value: true }])
        axios.post(process.env.REACT_APP_API_URL + "/api/employeeReview/addOrUpdateEmployeeReview", review, AxiosConfig.configValue("min"))
            .then((res) => {
                if (review.DeletedDateUtc) {
                    snackBar({ type: "success", text: "Review deleted", timeout: 3000 })
                    this.manageState([{ key: "reviewDex", value: -1 }])
                    this.props.updateEmployee()
                    this.getReviews()
                }
                else {
                    snackBar({ type: "success", text: "Review created", timeout: 3000 })
                    this.props.updateEmployee()
                    this.getReviews(res.data.EmployeeReviewId)
                }
            }).catch(err => {
                //console.log(err)
                snackBar({ type: "error", text: "Encountered an error", timeout: 3000 })
                this.manageState(
                    [
                        { key: "loading", value: false },
                        { key: "addReview", value: false },
                        { key: "deleteReview", value: false }
                    ])
            })
    }

    // getReviewStatus = (index: number) => {
    //     //@ts-ignore
    //     const status = this.state.reviews[index].EmployeeReviewStatusId
    //     //@ts-ignore
    //     const statusRef = this.state.reference.employeeReviewStaus
    //     if (statusRef) {
    //         for (let i = 0; i < statusRef.length; i++) {
    //             if (status === statusRef[i].id) {
    //                 return statusRef[i]
    //             }
    //         }
    //     }
    //     return { id: 0, text: "Unknown Status" }
    // }

    sortReviews = () => {
        if (this.state.ascending) {
            this.manageState([{ key: "reviews", value: this.state.reviews.sort((a: any, b: any) => (a.ReviewDate < b.ReviewDate) ? 1 : -1) }])
        } else {
            this.manageState([{ key: "reviews", value: this.state.reviews.sort((a: any, b: any) => (a.ReviewDate > b.ReviewDate) ? 1 : -1) }])
        }
    }

    render() {

        const state = this.state
        const props = this.props
        const reviews = this.state.reviews
        const readOnly = !this.props.readOnly
        // //console.log("??? reviews:", reviews)
        // console.log("state:", state)
        // //console.log("employee", this.props.employee)
        // console.log("reviews props", props)

        return (
            <div className="Reviews">
                {state.reviewDex === -1 && <span id="reviews-space-taker-upper" className="material-icons">grading</span>}
                {state.reviewDex === -1 && <ReviewsControlBar
                    sort={this.sortReviews}
                    ascending={state.ascending}
                    loading={state.loading}
                    manageParentState={this.manageState}
                    readOnly={readOnly}
                />}
                {state.reviewDex === -1 && reviews.length > 0  && reviews.map((reviewListItem: ReviewsTypes, index: number) => {
                    // The Reviews list item's EmployeeReviewId is the FieldResponse review id, which the
                    // Vault77 health scan reports as ExternalReviewId — match on it to flag bad reviews.
                    const reviewIssues = this.context.getReviewIssues(reviewListItem.EmployeeReviewId)
                    const hasIssues = reviewIssues.length > 0
                    return (
                    <div key={reviewListItem.EmployeeReviewId}>
                        <Accordion className={`ReviewItemCard${hasIssues ? " ReviewItemCard--unhealthy" : ""} ReviewItemcard${(this.props.isDelegation && (`${this.props.ReviewID}` !== `${reviewListItem.EmployeeReviewId}`)) ? "Hide" : "Show"}`}>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey={`${index}`}>
                                    <div className="ReviewHeader" onClick={() => this.manageState([{ key: "reviewDex", value: index }])}>
                                        <div className="ReviewHeaderColumnsLeft">
                                            <div className="ReviewHeaderLeftColumn">
                                                {/* <p>{moment(reviewListItem.ReviewDate).format("YYYY[-]MM[-]DD")}</p> */}
                                                <p>{moment(reviewListItem.ReviewDate).format("MM[/]DD[/]YYYY")}</p>
                                            </div>
                                            <div className="ReviewHeaderLeftColumn">
                                                {/* <p>{this.getReviewStatus(index).text}</p> */}
                                                <p>{reviewListItem.EmployeeReviewStatusDesc}</p>
                                            </div>
                                            <div className="ReviewHeaderLeftColumn">
                                                {!reviewListItem.ManagerReview && <span className="ReviewLeftColumnWaiting material-icons" id="review-header-left-column-waiting">hourglass_empty</span>}
                                                {reviewListItem.ManagerReview && <span className="ReviewLeftColumnDone material-icons" id="review-header-left-column-done">done</span>}
                                                <p>Manager Approval</p>
                                            </div>

                                            <div className="ReviewHeaderLeftColumn">
                                                {!reviewListItem.HRReview && <span className="ReviewLeftColumnWaiting material-icons" id="review-header-left-column-waiting">hourglass_empty</span>}
                                                {reviewListItem.HRReview && <span className="ReviewLeftColumnDone material-icons" id="review-header-left-column-done">done</span>}
                                                <p>Human Resources Approval</p>
                                            </div>
                                        </div>
                                        <div className="ReviewHeaderColumnsRight">
                                            <ReviewHealthBadge issues={reviewIssues} />
                                            <p className="ReviewHeaderLeftColumnInternalId">id: {reviewListItem.EmployeeReviewId}</p>
                                            <div className="ReviewHeaderRightColumn">
                                                {reviewListItem.EmployeeReviewStatusId === 3 && <span className="material-icons" id="review-header-left-column-completed">done</span>}
                                                <span className="material-icons">expand_more</span>
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Toggle>
                            </Card>
                        </Accordion>
                    </div>
                    )
                })}
                {state.reviewDex > -1 && state.reference &&
                    <Review
                        //@ts-ignore
                        EmployeeReviewId={state.reviews[state.reviewDex].EmployeeReviewId}
                        manageParentState={this.manageState}
                        updateStatus={this.updateStatus}
                        reviewReference={this.state.reference}
                        contextUser={props.contextUser}
                        deleteReview={this.addOrDeleteReview}
                        loading={state.loading}
                        employeeName={props.employee.DisplayName || "NA"}
                        doublePanelRef={this.props.doublePanelRef}
                        updateEmployee={this.props.updateEmployee}
                        detailedEmployeeData={this.props.detailedEmployeeData}
                        readOnly={readOnly}
                        reviewListItem={state.reviews[state.reviewDex]}
                        getReviews={this.getReviews}
                        addOrUpdateNotification={this.props.addOrUpdateNotification}
                    // isDirty={state.isDirty}
                    />}
                {state.addReview && state.reference && <AddReview
                    addReview={this.addOrDeleteReview}
                    manageParentState={this.manageState}
                    reference={state.reference}
                    employee={props.employee}
                    contextUser={props.contextUser}
                    loading={state.loading}
                />}
            </div>
        )
    }
}

export default Reviews